import { Component } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { catchError, of, switchMap } from 'rxjs';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent {
  registrationForm = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
    email: new FormControl(''),
  });

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router
  ) {}

  onSubmitRegistration(): void {
    this.userService
      .register({
        username: this.registrationForm.value.username!,
        password: this.registrationForm.value.password!,
        email: this.registrationForm.value.email!,
      })
      .pipe(
        switchMap(() => {
          const loginRequest = {
            username: this.registrationForm.value.username!,
            password: this.registrationForm.value.password!,
          };
          return this.authenticationService.login(loginRequest);
        }),
        catchError(() => {
          return of(false);
        })
      )
      .subscribe((result) => {
        if (result !== false) {
          this.router.navigateByUrl('verify-email');
        }
      });
  }
}
